import { InputAdornment, TextField, makeStyles } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles((theme) => ({
	numericInput: {
		textAlign: "right",
	},
	adornmentLabel: {
		color: theme.palette.text.secondary,
		fontSize: "1rem",
	},
}));

interface Props {
	title: string;
	value?: string | number;
	name?: string;
	onChange: (value: string, name: string) => void;
	readOnly?: boolean;
	placeholder?: string;
	isNumeric?: boolean;
	lengthCharacters?: number;
	styleLabel?: React.CSSProperties;
	styleTextBox?: React.CSSProperties;
}

export const SimpleTextControl = ({
	title,
	value,
	name,
	onChange,
	readOnly,
	placeholder,
	isNumeric,
	lengthCharacters,
	styleLabel,
	styleTextBox,
}: Props) => {
	const classes = useStyles();

	return (
		<TextField
			style={styleTextBox || {}}
			variant="outlined"
			fullWidth
			label={title}
			placeholder={placeholder || title}
			value={value || ""}
			onChange={(e) => onChange(e.target.value, name || "")}
			inputProps={{
				maxLength: lengthCharacters || null,
				className: isNumeric ? classes.numericInput : "",
			}}
			InputProps={{
				readOnly: readOnly,
				startAdornment: (
					<InputAdornment position="start">
						<span style={styleLabel || {}} className={classes.adornmentLabel}>
							{title}
						</span>
					</InputAdornment>
				),
			}}
		/>
	);
};
